import { ComparerResult } from "../common";

export function isOutrightComparer<T extends { isOutright?: boolean }>(a: T, b: T): ComparerResult {
    if (!!a.isOutright === !!b.isOutright) return 0;

    return !!a.isOutright ? 1 : -1;
}

